const DislikeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path d="M18 16H20C21.1046 16 22 15.1046 22 14V5C22 3.89543 21.1046 3 20 3H18C16.8954 3 16 3.89543 16 5V14C16 15.1046 16.8954 16 18 16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.12311 3H11.7889C12.5786 3 13.3506 3.23375 14.0077 3.6718L15.5547 4.70313C15.8329 4.8886 16 5.20083 16 5.53518V13.7344C16 13.9085 15.9546 14.0795 15.8682 14.2306L12 21H10.6713C8.67455 21 7.48357 18.7746 8.59117 17.1133L10 15H4.56155C3.26041 15 2.30569 13.7772 2.62127 12.5149L4.24253 6.02986C4.6877 4.24919 6.28764 3 8.12311 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
};

export default DislikeIcon;
